import Loader from "@components/common/Loader";
import StaticHeader from "@components/common/Header/static-header";
import { useEffect } from "react";
import { authSSOLogin } from "@services/auth.service";
import { getValue } from "@utils/lodash";

function SSOLoginPage(props: any) {
  useEffect(() => {
    handleSSOLogin();
  }, []);

  const handleSSOLogin = async () => {
    try {
      let resp = await authSSOLogin("");
      if (getValue(resp, `data`, "")) {
        // window.open(getValue(resp, `data`, ""));
        window.location.href = getValue(resp, `data`, "");
      }else{
        window.location.href = `/login`
      }
    } catch (error) {}
  };
  return (
    <div>
      <StaticHeader />
      <Loader />
    </div>
  );
}

export default SSOLoginPage;
